import { render, staticRenderFns } from "./chart2.vue?vue&type=template&id=140ef2f3&scoped=true&"
import script from "./chart2.vue?vue&type=script&lang=js&"
export * from "./chart2.vue?vue&type=script&lang=js&"
import style0 from "./chart2.vue?vue&type=style&index=0&id=140ef2f3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "140ef2f3",
  null
  
)

export default component.exports